import { useIsMobile } from "../context/MobileContext"
import useLabForm from "../hooks/useLabForm"
import { lab_list, webInfo, Orders } from "../utils/types"
import { useState, useEffect } from "react"
import { roundValor, months, BASE_URL, inputStyle, UFs, inputStyleInvalid } from "../utils/Scripts";
import axios from 'axios'
import {doc, onSnapshot} from '@firebase/firestore'
import { db } from "../firebase";
import { CepInput } from "./CepInput";
import { CircularProgress } from "@mui/material";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import logo_pagarme from '../../images/logo-pagarme.png'
import LockIcon from '@mui/icons-material/Lock';
import PersonIcon from '@mui/icons-material/Person';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

declare global {
  interface Window {
    PagarmeCheckout: any;
  }
}

const CardInput:React.FC<{
    setCardValue:React.Dispatch<React.SetStateAction<string>>
    validate:boolean
}>=({
    setCardValue,
    validate
})=>{



    const [displayValue, setDisplayValue] = useState(""); // what the user sees

    const formatCardNumber = (value: string) => {
        return value
        .replace(/\D/g, "")                // remove non-digits
        .replace(/(\d{4})(?=\d)/g, "$1 "); // space every 4 digits
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const digitsOnly = e.target.value.replace(/\D/g, ""); // raw digits
        setCardValue(digitsOnly);
        setDisplayValue(formatCardNumber(digitsOnly)); // formatted for display
    };
    const isMobile = useIsMobile()
    return(
        <input type='text' id='cardnumber' style={validate?inputStyle():inputStyleInvalid()} autoComplete='off'
        value={displayValue}
        onChange={handleChange}
        maxLength={19}
        />
    )
}

const DateInput:React.FC<{
    setDateValue: React.Dispatch<React.SetStateAction<string>>,
    validate: boolean
}>=({
    setDateValue,
    validate
})=>{
    const isMobile = useIsMobile()

    const [displayValue, setDisplayValue] = useState("");

  const formatExpiryDate = (value: string) => {
    const digits = value.replace(/\D/g, ""); // only digits

    // MM
    if (digits.length === 0) return "";
    if (digits.length <= 2) return digits;

    // MM/YY
    return digits.substring(0, 2) + "/" + digits.substring(2, 4);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digitsOnly = e.target.value.replace(/\D/g, "");
    setDateValue(digitsOnly); // store as MMYY
    setDisplayValue(formatExpiryDate(digitsOnly)); // show as MM/YY
  };

    return(
    <input type='text' id='expirydate' style={validate?inputStyle(isMobile?'100px':'10vw'):inputStyleInvalid(isMobile?'100px':'10vw')} autoComplete='off'
        value={displayValue}
        onChange={handleChange}
        maxLength={5} // MM/YY
    />
    )
}


const CardPayment:React.FC<{
    setDisplay: React.Dispatch<React.SetStateAction<number>>,
    nome: string,
    cpf: string,
    email: string,
    cupom: string,
    preco: string,
    labData: Partial<lab_list[0]>[],
    webInfo: webInfo,
}> =({
    setDisplay,
    nome,
    cpf,
    email,
    cupom,
    preco,
    labData,
    webInfo
})=>{

    const {online, setOnline, selectedId}:any = useLabForm()
    const isMobile = useIsMobile()
    const [cardValue, setCardValue] = useState("")
    const [dateValue, setDateValue] = useState("")
    const [cvv, setCvv] = useState('')
    const [cardName, setCardName] = useState('')
    const [loadingPayment, setLoadingpayent] = useState(false)
    const [selectedInstallment, setSelectedInstallment] = useState<number>(1);
    const [address, setAddress] = useState('')
    const [cep, setCep] = useState('')
    const [cidade, setCidade] = useState('Rio de Janeiro')
    const [estado, setEstado] = useState('RJ')
    const [paymentStatus, setPaymentStatus] = useState(0)
    const [loadingCep, setLoadingCep] = useState(false)
    const [validate, setValidate] = useState({cardNumber: true, expDate:true, cvv:true, cardName:true, cep: true, address:true, cidade:true})

    const handleCvv = (e: React.ChangeEvent<HTMLInputElement>) => {
            // Only keep digits, max 3 characters
            const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 3);
            setCvv(digitsOnly);
    };

    function validate_data(cardNumber:string, expDate:string, cvv:string, cardName:string, cep:string, address:string, cidade:string){
      let isValid = {cardNumber: false, expDate:false, cvv:false, cardName:false, cep: false, address:false, cidade:false}
      if(cardNumber.length===16){
        isValid.cardNumber = true
      }
      if(expDate.length===4){
        isValid.expDate = true
      }
      if(cvv.length===3){
        isValid.cvv = true
      }
      if(cardName.length>4){
        isValid.cardName = true
      }
      if(cep.length===8){
        isValid.cep = true
      }
      if(address.length>4){
        isValid.address = true
      }
      if(cidade.length>4){
        isValid.cidade = true
      }
      return(isValid)
    }
    
    async function generateCardToken(cardData: {
        number: string
        holder_name: string
        exp_month: string
        exp_year: string
        cvv: string
        }) {
        // const publicKey = 'pk_test_4lYo2pVuNJF2LpN5'
        const publicKey = 'pk_test_4lYo2pVuNJF2LpN5'
        const url = `https://api.pagar.me/core/v5/tokens?appId=${publicKey}`

        const response = await axios.post(url, { card: cardData })
        return response.data.id // esse é o card_token seguro
    }

    async function handlePayment(){

        const valObj:any = validate_data(cardValue, dateValue, cvv, cardName, cep, address, cidade)
        let val = true
        Object.keys(valObj).forEach((key)=>{
          if(!valObj[key]){
            val = false
          }
        })
        if(val){
            setLoadingpayent(true)
            const cardData = {
                number: cardValue,
                holder_name:cardName,
                exp_month: dateValue.slice(0,2),
                exp_year: dateValue.slice(2,4),
                cvv: cvv
            }
            const token = await generateCardToken(cardData)
            if(token){
                const orderObject:Orders = {
                    payment_id: '',
                    nome:nome,
                    email:email.toUpperCase(),
                    cpf: cpf,
                    online: online,
                    pix: false,
                    valor:Number(installments_options()[selectedInstallment-1].total),
                    data: new Date().toJSON().slice(0,10),
                    cupom: cupom,
                    lab_id: selectedId,
                    status: 'pending'
                }

                await axios.post(BASE_URL+'payment_card',{
                    card_token: token,
                    billing_address: {
                        line_1: address,
                        zip_code: cep,
                        city: cidade,
                        state: estado,
                        country: 'BR'
                    },
                    installments: selectedInstallment,
                    order: orderObject
                }).then((res)=>{
                    const order_doc_id = res.data.doc_id
                    if(order_doc_id){
                        const docRef = doc(db, 'arcalab_orders', order_doc_id)
                        const unsubscribe = onSnapshot(docRef, (snapshot)=>{
                            if(snapshot.exists()){
                                const data = snapshot.data()
                                if(data.status==='paid'){
                                    setLoadingpayent(false)
                                    setPaymentStatus(1)
                                    unsubscribe()
                                } else if (data.status==='failed'){
                                    setLoadingpayent(false)
                                    setPaymentStatus(2)
                                    unsubscribe()
                                }
                            }
                        })
                    }
                })
                .catch(()=>{
                    setLoadingpayent(false)
                })
            } else {
                setLoadingpayent(false)
            }
        } else {
            setValidate(valObj)
        }
    }

    const installments_options = () => {
        const price_mode = online?'price_online':'price_presencial'
        const lab_price = () => {
        // Find lab and get price safely
        const lab = labData.find((lab) => lab.id === selectedId);
        const actual_price = Number(lab?.[price_mode] ?? 0);

        if (cupom) {
            // Find the coupon safely
            const couponObj = webInfo.cupons.find((c) => c.name === cupom);

            // If coupon not found, use 1 to avoid division by undefined
            const couponValue = couponObj?.value ?? 1;

            return actual_price - actual_price / couponValue;
        } else {
            return actual_price;
        }
        };

        return webInfo.taxas.map((taxa: number, index: number) => {
            let new_value = Number((lab_price() * taxa).toFixed(2))
            return({
            installments: index + 1,
            total: new_value,
            parcela: new_value / (index + 1),
        })});
    };

    const lab_date = labData.find(lab=>lab.id===selectedId)?.date

    async function buscarEndereco(cepNumero: string) {
        setLoadingCep(true)
        try {
          const { data } = await axios.get(`https://viacep.com.br/ws/${cepNumero}/json/`);
          if (!data.erro) {
            setAddress(data.logradouro || "");
            setCidade(data.localidade || "");
            setEstado(data.uf || "");
            setLoadingCep(false)
          }
        } catch (err) {
          setLoadingCep(false)
          console.error("Erro ao buscar CEP:", err);
        }
    }

    useEffect(()=>{
        if (cep.length === 8 && (!address)) {
            buscarEndereco(cep);
        }
    },[cep])


    return(
        <div style={{fontFamily:'Arial', color:'#fff', textAlign:'left', width:isMobile?'100%':'510px', margin:'2vh auto 0'}}>
            <div style={{background:'linear-gradient(304deg,rgba(232, 232, 232, 1) 0%, rgba(209, 209, 209, 1) 100%)', backgroundColor:'#e8e8e8',
                 display:'flex', color:'#000', padding:'20px', boxSizing:'border-box', borderRadius:'7px', marginBottom:'20px', alignItems:'center'}}>
                    <div>
                        <div style={{display:'flex', alignItems:'center'}}>
                            <PersonIcon/>
                            <div style={{fontSize:"20px", fontWeight:'500', marginLeft:'3px'}}>
                                {nome.toUpperCase()}
                            </div>
                        </div>
                        
                        <div style={{fontSize:'12px', marginTop:'3px'}}>
                            CPF: {cpf.slice(0,3)}.{cpf.slice(3,6)}.{cpf.slice(6,9)}-{cpf.slice(9,11)}
                        </div>
                        <div style={{}}>
                            {email}
                        </div>
                        {cupom&&(
                        <div style={{borderRadius:'5px', backgroundColor:'#2E2E2E', display:'inline-block', padding:'5px', fontSize:'10px', cursor:'default', width:'fit-content', margin:'3px 0', color:'#fff'}}>
                                Cupom aplicado: <span style={{fontWeight:'600', fontSize:'9px'}}>{cupom}</span>
                        </div>
                        )}
                        <div style={{fontWeight:'600', fontSize:"13px", marginTop:'5px'}}>
                            MODALIDADE: {online?'ONLINE':'PRESENCIAL'}
                        </div>
                        {paymentStatus===0&&
                        <div style={{width:'fit-content', cursor:'pointer', fontWeight:'600', fontSize:'12px', marginTop:'10px', display:'flex'}}
                        onClick={()=>{setDisplay(0)}}
                        >
                            <BorderColorIcon style={{fontSize:'14px', marginRight:'4px'}}/>
                            <div>
                            Editar Informações
                            </div>
                        </div>
                        }
                    </div>
                    <div style={{marginLeft:'auto', display:'flex', flexDirection:'column', alignItems:'center',fontWeight:'600'}}>
                        <div style={{ fontSize:'50px'}}>
                            {lab_date?.slice(0,2)}
                        </div>
                        <div>
                            {months[Number(lab_date?.slice(3,5))-1].toUpperCase()}
                        </div>
                    </div>
            </div>
            {paymentStatus===0&&(
                <div style={{color:'#fff', width:'100%'}}>
                    <div style={{backgroundColor:'#4bab58', background:'linear-gradient(90deg,rgba(75, 171, 88, 1) 0%, rgba(30, 143, 53, 1) 100%)', display:'flex', justifyContent:'center', borderRadius:'7px', marginBottom:'20px', alignItems:'center', padding:'5px 0', cursor:'default'}}>
                        <LockIcon style={{marginRight:'3px'}}/>
                        <div style={{transform:'translateY(2px)', fontWeight:'600'}}>Compra processada por</div>
                        <div style={{backgroundImage:`url(${logo_pagarme})`, backgroundSize:'cover', width:'100px', height:'40px', marginLeft:'8px', filter:'brightness(0) invert(1)', transform:'translateY(-1px)'}}/>
                    </div>
                    <div>
                        <div>
                            Número do Cartão
                        </div>
                        <div style={{width:'100%'}}>
                            <CardInput setCardValue={setCardValue} validate={validate.cardNumber}/>
                        </div>
                    </div>
                    <div style={{display:'flex', margin:'5px 0'}}>
                        <div>
                            <div>
                                Data de Vencimento
                            </div>
                            <div>
                                <DateInput setDateValue={setDateValue} validate={validate.expDate}/>
                            </div>
                        </div>
                        <div style={{marginLeft:'10px'}}>
                            <div>
                                CVV
                            </div>
                            <div>
                                <input type="text"
                                inputMode="numeric"
                                style={validate.cvv?inputStyle('50px'):inputStyleInvalid('50px')} autoComplete='off'
                                onChange={handleCvv}
                                value={cvv}
                                maxLength={3}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{width:'100%'}}>
                        <div>
                            Nome no Cartão
                        </div>
                        <div style={{width:'100%'}}>
                            <input type='text' id='cardname' style={validate.cardName?inputStyle():inputStyleInvalid()} autoComplete='off'
                            onChange={(e) => {setCardName(e.target.value)}}
                            />
                        </div>
                    </div>
                    <div style={{width:'100%', marginTop:'30px'}}>
                        <div style={{color:'#616161', fontSize:'13px', fontWeight:'600'}}>ENDEREÇO DE FATURAMENTO</div>
                        <div style={{backgroundColor:'#3b3b3b', width:'100%', height:'4px'}}/>
                    </div>
                    <div style={{marginTop:'10px'}}>
                        <div>
                            CEP
                        </div>
                        <div>
                            <CepInput setCep={setCep} cep={cep} validate={validate.cep} />
                        </div>
                    </div>
                    <div style={{margin:'7px 0', width:'100%'}} >
                        <div>
                            Endereço
                        </div>
                        <div style={{position:'relative', display:'inline-block', width:'100%'}}>
                            <input type='text' id='adress' style={validate.address?inputStyle():inputStyleInvalid()} autoComplete='off'
                            onChange={(e) => {setAddress(e.target.value)}}
                            value={address}
                            />
                            {loadingCep&&(
                            <div style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)" }}>
                            <CircularProgress size={20} />
                            </div>
                            )}
                        </div>
                    </div>
                    <div style={{display:'flex', width:'100%'}}>
                        <div style={{width:'75%'}}>
                            <div>
                                Cidade
                            </div>
                            <div style={{position: "relative", display: "inline-block", width:'100%'}}>
                                <input type='text' id='cidade' style={validate.cidade?inputStyle():inputStyleInvalid()} autoComplete='off'
                                onChange={(e) => {setCidade(e.target.value)}}
                                value={cidade}
                                />
                                {loadingCep&&(
                                <div style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)" }}>
                                <CircularProgress size={20} />
                                </div>
                                )}
                            </div>
                        </div>
                        <div style={{width:'fit-content', marginLeft:'auto'}}>
                            <div>
                                Estado
                            </div>
                            <div style={{position: "relative", display: "inline-block", width:'100%'}}>
                                <select
                                value={estado}
                                onChange={(e) => setEstado(e.target.value)}
                                style={{...inputStyle('80px'), color:'#fff'}}
                                >
                                {UFs.map((uf) => (
                                    <option key={uf} value={uf}>
                                    {uf}
                                    </option>
                                ))}
                                </select>
                                {/* <input type='text' id='estado' style={isMobile?inputStyle('10vw'):inputStyle()} autoComplete='off'
                                onChange={(e) => {setEstado(e.target.value)}}
                                value={estado}
                                /> */}
                                {loadingCep&&(
                                <div style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)" }}>
                                <CircularProgress size={20} />
                                </div>
                                )}
                            </div>
                    </div>
                    </div>
                    
                    
                    <div style={{display:'flex'}}>
                        <div style={{margin:'5px 0 20px'}}>
                            <div>
                                Parcelamento
                            </div>
                            <div>
                                <select
                                value={selectedInstallment ?? ""}
                                onChange={(e) => setSelectedInstallment(Number(e.target.value))}
                                >
                                {installments_options().map((opt) => (
                                    <option key={opt.installments} value={opt.installments}>
                                    {opt.installments}x de R${opt.parcela.toFixed(2).replace('.',',')} (Total: R${opt.total.toFixed(2).replace('.',',')})
                                    </option>
                                ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div style={{border:'2px solid #fff', padding:'10px', borderRadius:'10px', cursor:loadingPayment?'default':'pointer', marginTop:'5px', textAlign:'center', fontFamily:'Digital', fontSize:'12px'}} onClick={()=>{
                        if(!loadingPayment){handlePayment()}
                    }}>
                        {!loadingPayment&&'CONCLUIR PAGAMENTO'}
                        {loadingPayment&&(
                            <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <div>
                                    PROCESSANDO
                                </div>
                                <CircularProgress size={12} style={{color:'#fff', marginLeft:'10px'}}/>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {paymentStatus===1&&(
                <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center', margin:'50px 0'}}>
                    <CheckCircleIcon style={{fontSize:'100px',color:'#4bab58', filter:'linear-gradient(90deg,rgba(75, 171, 88, 1) 0%, rgba(30, 143, 53, 1) 100%)'}}/>
                    <span style={{fontSize:'30px'}}>Pagamento Confirmado</span><br/>Sua presença já está confirmada no laboratório.
                </div>
            )}
            {paymentStatus===2&&(
                <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center', margin:'50px 0'}}>
                    <ErrorIcon style={{fontSize:'100px',color:'#e36464', filter:'linear-gradient(90deg,rgba(227, 100, 100, 1) 0%, rgba(209, 40, 40, 1) 100%)'}}/>
                    <span style={{fontSize:'30px'}}>Falha no Pagamento</span><br/><span style={{cursor:'pointer'}}onClick={()=>{setPaymentStatus(0)}}>Clique aqui para efetuar o pagamento novamente.</span><br/>
                    <span style={{color:'#616161', fontSize:'12px'}}>Se você acredita que o pagamento foi realizado com sucesso e não recebeu o e-mail de confirmação, entre em contato com contato@arcaentretenimento.com.br</span>
                </div>
            )}
        </div>
    )
}

export default CardPayment